import { render, staticRenderFns } from "./ListRowDetail.vue?vue&type=template&id=48389dc0"
import script from "./ListRowDetail.vue?vue&type=script&lang=js"
export * from "./ListRowDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports